import { TextAlignType, TextFormatType } from '@nextgen-web-framework/all';
import { CMSTransformerDataType } from '../../types/common';
import { TextOnlyPropType } from '../../../components/TextOnly/types/protoTypes';
import { cmsColorOptionType } from '../../../components/TextOnly/types/enum';
import { ComponentType } from '../../registries/types/propTypes';

const transformTextOnly = (props: CMSTransformerDataType): TextOnlyPropType => {
  const textOnlyCMSData = Array.isArray(props?.text_only) ? props?.text_only[0] : props?.text_only;

  const { display_title, color_options = { hex_code: '', select_color_options: '' } } = textOnlyCMSData;
  const { hex_code, select_color_options } = color_options;
  const isHexCode: boolean = select_color_options === cmsColorOptionType.HEXCODE;

  const titleConfig = {
    text: display_title?.text,
    formatType: display_title?.heading_type ?? TextFormatType.H2,
    alignment: display_title?.alignment ?? TextAlignType.CENTER,
    color: isHexCode ? hex_code?.title_color : '',
  };

  const descriptionConfig = {
    description: textOnlyCMSData?.description,
    color: isHexCode ? hex_code?.description_color : '',
  };

  const payload: TextOnlyPropType = {
    componentType: ComponentType.text_only,
    titleConfig,
    descriptionConfig,
    rounded: textOnlyCMSData?.rounded ?? true,
    bgColor: isHexCode ? hex_code?.text_background_color : '',
    theme: select_color_options === cmsColorOptionType.THEME ? color_options?.theme_color?.color : '',
  };

  return payload;
};
export default transformTextOnly;
